import React from "react";
import cls from "./styles.module.scss";

export interface ContainerLoaderProps {
  size?: number | string;
  borderSize?: number | string;
  color?: string;
}

const ContainerLoader: React.FC<ContainerLoaderProps> = ({
  size = 40,
  borderSize = 4,
  color = __SERVICE_NAME__ === "sravni_dohod"
    ? "var(--color-bronze)"
    : "var(--color-primary)",
}) => {
  const dimension = typeof size === "number" ? `${size}px` : size;
  const bw = typeof borderSize === "number" ? `${borderSize}px` : borderSize;

  return (
    <div className={cls.wrapper}>
      <div
        className={cls.spinner}
        style={{
          width: dimension,
          height: dimension,
          borderWidth: bw,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default ContainerLoader;
